module.exports = __webpack_public_path__ + "static/img/rank_240.eeb56bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_240.png
// module id = gUei
// module chunks = 1